import styled from 'styled-components';

export const ContainerDiv = styled.div`
  position: relative;
  margin: auto;
  width: ${({ theme }) => theme.container.lg};
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    width: ${({ theme }) => theme.container.md};
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    width: ${({ theme }) => theme.container.sm};
  }
`;
